import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=5ae1e538&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ae1e538')) {
      api.createRecord('5ae1e538', component.options)
    } else {
      api.reload('5ae1e538', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=5ae1e538&", function () {
      api.rerender('5ae1e538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/views/Dashboard.vue"
export default component.exports